module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Thin.7adb7d4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Thin.woff
// module id = kSkb
// module chunks = 0